import React from "react";
import { capFirst, TextOverflow } from "utils/common";
import { Icon } from "rhombus-react";
import PropTypes from "prop-types";

import "./VariablesTable.css";

export default function VariablesTable({ variables, className }) {
	const rows = variables.map((variable) => {
		const { name, type } = variable || {};
		let formattedType = capFirst(type);
		let nameContent = <TextOverflow value={name} />;

		return (
			<tr key={name}>
				<td className="variable-name-column">
					<span className="variable-name-container">
						<Icon name={`asset${formattedType}`} title={type} />
						{nameContent}
					</span>
				</td>
				<td className="variable-type-column">{formattedType}</td>
			</tr>
		);
	});

	return (
		<table className={`variables-table basic-table ${className}`}>
			<thead>
				<tr>
					<th className="variable-name-column">Variable Name</th>
					<th className="variable-type-column">Variable Type</th>
				</tr>
			</thead>
			<tbody>
				{rows}
			</tbody>
		</table>
	);
}

VariablesTable.displayName = "VariablesTable";

VariablesTable.propTypes = {
	variables: PropTypes.arrayOf(PropTypes.shape({
		name: PropTypes.string,
		type: PropTypes.string,
	})),
	className: PropTypes.string,
};

VariablesTable.defaultProps = {
	variables: [],
	className: "",
};
